import {parseToFloat, roundOff} from 'Utils/helpers/Numeric';
import {parseData} from 'Utils/helpers/SRListHelpers';

export const getTicketGridData = (
  tableData,
  sortOrder,
  currentSortCriteria,
  isSortingEnabled,
  buttonList,
) => {
  const header = [
    {label: 'Item', value: 'eventBookingLineId'},
    {label: 'Ticket Type', value: 'type'},
    {label: '# Tickets', value: 'quantity'},
    {label: 'Price/Ticket', value: 'pricePerUnit'},
    {label: 'Status', value: 'status'},
    {label: 'Booking Fee', value: 'bookingFee'},
    {label: 'No Discount', value: 'isAvailDiscount'},
    {label: 'Auto Discount % Applied', value: 'autoDiscountPercentageApplied'},
    {label: 'Total Price After Discount', value: 'totalPriceAfterDiscount'},
    {label: '', value: 'buttons'},
  ];
  tableData = ((Array.isArray(tableData) && tableData) || []).map((data) => {
    return {
      ticketLineId: data?.additionalInfo?.ticketLineId || '',
      type: data.type,
      quantity: data.quantity,
      pricePerUnit: roundOff(parseToFloat(data.pricePerUnit), 2),
      status: data.status,
      bookingFee: roundOff(parseToFloat(data.bookingFee), 2),
      isAvailDiscount: data.isAvailDiscount ? 'Yes' : 'No',
      autoDiscountPercentageApplied: data.autoDiscountPercentageApplied,
      totalPriceAfterDiscount: roundOff(parseToFloat(data.totalPriceAfterDiscount), 2),
      buttons: ['updateButton', 'deleteButton'],
    };
  });
  return parseData(header, tableData, sortOrder, currentSortCriteria, isSortingEnabled);
};
